/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import { Breadcrumbs as BreadcrumbsCore, type BreadcrumbsProps as BreadcrumbsCoreProps, type ContextValue, useContextProps } from 'react-aria-components';

interface BreadcrumbsProps<T> extends Omit<BreadcrumbsCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const BreadcrumbsContext = createContext<ContextValue<BreadcrumbsProps<object>, HTMLOListElement>>({});

const Breadcrumbs = forwardRef((props: BreadcrumbsProps<object>, ref: ForwardedRef<HTMLOListElement>) => {
  [props, ref] = useContextProps(props, ref, BreadcrumbsContext);

  const { style, children, ...coreProps } = props;

  return (
    <BreadcrumbsCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      {children}
    </BreadcrumbsCore>
  );
}) as <T>(p: BreadcrumbsProps<T> & { ref?: ForwardedRef<HTMLOListElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    margin: 0,
    padding: 0,
    gap: 8,
    listStyle: 'none',
    alignItems: 'center',
    display: 'flex',
  },
});

export { Breadcrumbs, BreadcrumbsContext, type BreadcrumbsProps };
